<!-- @veltra/icons generated sha256:6ea601a870613316 gen:8 source:src/svg/normal/house.svg -->
<script setup lang="ts">
defineOptions({ name: 'House' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M14.494 7.787 8.36 1.652a.514.514 0 0 0-.718 0L1.506 7.787a.494.494 0 0 0-.017.702l.008.008a.5.5 0 0 0 .707.006L3 7.707v5.807c0 .552.44.986.992.986h8.016a.98.98 0 0 0 .992-.986V7.707l.796.796a.5.5 0 0 0 .707-.006l.008-.008a.494.494 0 0 0-.017-.702M4 6.707l4-4 4 4V13.5H4zM6.5 12a.5.5 0 0 1-.5-.496c0-.276.225-.504.5-.504h3c.275 0 .5.228.5.496a.504.504 0 0 1-.5.504z"
    />
  </svg>
</template>
